import React, { Component } from "react";
import { Link } from "react-router-dom";
import RightMenu from "../RightMenu";
import RightIconMenu from "../RightIconMenu";
import axios from "axios";
import "./index.css";
//import CalendarPicker from 'rc-calendar';
export default class View_type_23 extends Component {
    constructor(props) {
        super(props);
        //console.log("View_type_23 props: ", props);
        var data = Array.isArray(props.data) ? props.data[0] : props.data;
        this.state = {
            data: data,
            rightMenu: data.right_menu ? data.right_menu : [],
            title: data.title ? data.title : "",
            tabs: data.tabs ? props.data.tabs : [],
            calendar: data.calendar ? data.calendar : null,
            content: data.content ? data.content : [],
            text: data.text ? data.text : [],
            lead: data.lead ? data.lead : [],
            read_more: data.read_more ? data.read_more : [],
            list: data.list ? data.list : [],
            rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],
            middleUrl: props.middleUrl,
        };
        //console.log("View_type_23 state: ", this.state);
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const searchParam = urlParams.get('search');
        const searchData = document.getElementById('searchData')

        if (searchParam) {
            if (searchData) {
                searchData.value = searchParam
            }
            this.submitHandler(null, searchParam)
        }
    }

    createMarkup(item) {
        return { __html: item };
    }

    submitHandler = (e, search) => {
        if (e) {
            e.preventDefault();
        }

        const params = new URLSearchParams();
        params.append('search', search);

        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set('search', search);
        window.history.pushState({}, '', currentUrl);

        axios({
            method: 'post',
            url: this.state.middleUrl,
            data: `search=${search}`,
        })
            .then(response => {
                this.setState({
                    data: response.data,
                    text: response.data.text,
                    search: true
                });
                //console.log("List update: ", this.state);
            });
    }

    render() {
        var _this = this;
        var var1 = this.state.title ? this.state.title : "";
        var search = this.state.data.search ? this.state.data.search : [];
        var calendar = this.state.calendar ? (
            <a href={this.state.calendar.url}>
                <div className="vt23-calendar">
                    <img className="vt23-calendar-img" src={this.state.calendar.img} />
                    {this.state.calendar.text}
                </div>
            </a>
        ) : null;
        let input_item = null;
        if (search.input_main_active == true || this.state.search) {
            input_item =
                <div
                    className="vt23 left col-xs-12 col-sm-12 col-md-12 col-lg-12 vt23-form search-container">
                    <form action={search.action_url} method="POST" onSubmit={e => this.submitHandler(e, e.target.search.value)}>
                        <input type="search" placeholder={search.input_main_placeholder} ref="search" name="search" id="searchData" aria-label="searchData" />
                        <input type="submit" placeholder={search.input_main_placeholder} value=""
                            style={{
                                backgroundImage: ("/static/media/search/search-icon.png")
                            }}
                            aria-label="search"
                        />
                    </form>
                </div>


        }
        else {
            input_item =
                <div
                    className="vt23 left col-xs-12 col-sm-12 col-md-12 col-lg-12 vt23-form search-container">
                </div>
        }
        return (
            <div className="vt23">
                <div className="vt23 left col-xs-12 col-sm-12 col-md-8 col-lg-9">
                    <div className="vt23 row links_underline">
                        <div className="vt23-title">
                            <div
                                className="vt23-title-name artists-pageTitle"
                                dangerouslySetInnerHTML={{ __html: var1 }} //KONTAKT header
                            />
                            <div className="vt23-title-tabs">
                                {this.state.tabs.map(function (object, i) {
                                    if (object.active === 1) {
                                        return (
                                            <div
                                                className="vt23 col-xs-6 col-sm-6 col-md-6 col-lg-6"
                                                key={i}
                                            >
                                                <div className="vt23 tab-checked">
                                                    <a href={"/" + object.link}>{object.title}</a>
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div
                                                className="vt23 col-xs-6 col-sm-6 col-md-6 col-lg-6"
                                                key={i}
                                            >
                                                <a href={"/" + object.link}>{object.title}</a>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </div>
                        <div className="vt23-lead">
                            <div
                                dangerouslySetInnerHTML={_this.createMarkup(this.state.lead)}
                            />
                        </div>

                        {
                            input_item ? input_item : null

                        }

                        <div>
                            {this.state.data.image && (
                                <img
                                    className="img-responsive vt23-image"
                                    src={this.state.data.image}
                                />
                            )}
                        </div>
                        <div className="vt23-content">
                            <div
                                dangerouslySetInnerHTML={_this.createMarkup(this.state.text)}
                            />
                        </div>
                    </div>
                </div>
                <div className="vt23 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
                    {this.state.rightMenu.length ? (
                        <RightMenu data={this.state.rightMenu} />
                    ) : null}
                    {this.state.calendar && (
                        <div className="vt-22 calendar-lg">{calendar}</div>
                    )}
                    {this.state.rightIconMenu &&
                        <RightIconMenu data={this.state.rightIconMenu} />
                    }
                </div>
                {this.state.list ? (
                    <div
                        className="row col-md-12"
                        style={{ flexWrap: "wrap", display: "flex" }}
                    >
                        {this.state.data.list.map((object, i) => {
                            if (object.cols) {
                                var columnsNumber = null
                                switch (object.cols) {
                                    case 2:
                                        columnsNumber = 6
                                        break;
                                    case 3:
                                        columnsNumber = 4
                                        break;
                                    case 4:
                                        columnsNumber = 3
                                        break;
                                    case 6:
                                        columnsNumber = 2
                                        break;
                                    default:
                                        return null;
                                }
                            }
                            return (
                                <div
                                    className={`vt23-col col-xs-12 col-sm-${columnsNumber} col-md-${columnsNumber} col-lg-${columnsNumber} text-center `}
                                    key={i}
                                    style={{
                                        marginBottom: '20px'
                                    }}
                                >
                                    <div className="vt23 row">
                                        {object && object.img ? (
                                            <div
                                                onClick={() => (window.location.href = `${object.url}`)}
                                                className="vt23 middle-postblock bg-test-1"
                                                style={{
                                                    cursor: "pointer",
                                                    background: `url(${object.img})`
                                                }}
                                            >
                                            </div>
                                        ) : null}

                                        {object && (
                                            <div className="vt23-middle-postblock--desc">
                                                <a href={`${object.url}`}>
                                                    <div
                                                        dangerouslySetInnerHTML={_this.createMarkup(
                                                            object.text
                                                        )}
                                                    />
                                                </a>
                                                {object.url && (
                                                    <div className="middle-addelem">
                                                        <a href={object.url} className="more_button" aria-label="read more">
                                                            {" "}
                                                        </a>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="vt23__gallery-boxes row col-md-11 col-sm-12">
                        {this.state.list.map(function (object, i) {
                            return (
                                <div
                                    className="vt23-col col-xs-12 col-sm-4 col-md-4 col-lg-4 text-center"
                                    key={i}
                                >
                                    <div className="vt23 row">
                                        <div
                                            onClick={() => (window.location.href = `${object.url}`)}
                                            className="vt23 middle-postblock"
                                            style={{
                                                cursor: "pointer",
                                                background: `url(${object.img})`
                                            }}
                                        >
                                        </div>
                                        {object && (
                                            <div className="vt23-middle-postblock--desc">
                                                <a href={`${object.url}`}>
                                                    <div
                                                        dangerouslySetInnerHTML={_this.createMarkup(
                                                            object.text
                                                        )}
                                                    />
                                                </a>
                                                {object.url && (
                                                    <div className="middle-addelem">
                                                        <a href={object.url} className="more_button">
                                                            {" "}
                                                        </a>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

            </div>
        );
    }
}

var x = document.getElementsByClassName('vt23 middle-postblock').length;


// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_23/index.js